import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../hooks";
import {
  handleNewConversationRequest,
  setIsGenerateImage,
  setIsGlobalSearch,
  setShowPlansModal,
} from "./chatsSlice";

export const useMethodHelper = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const executeAction = (actionName: string) => {
    switch (actionName) {
      case "NEW_CONVERSATION":
        dispatch(handleNewConversationRequest());
        dispatch(setIsGenerateImage(false));
        dispatch(setIsGlobalSearch(false));
        break;
      case "NavigateToLogin":
        const shouldSaveLocation = location.pathname.includes("workflows/share");
        if (shouldSaveLocation) 
          sessionStorage.setItem("redirectAfterLogin", location.pathname);
        navigate("/account/login");
        break;
      case "OpenUpgradePlans":
        dispatch(setShowPlansModal(true));
        break;
      default:
        console.warn(`Unhandled action: ${actionName}`);
    }
  };

  return executeAction;
};

// ===============================================================
//Set random background color if there is no user image.

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringAvatar = (name: any) => {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
};

// Handle date formate.
export const formatDate = (dateString: any) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", options);
};

export const handleDownload = (imageSrc: any) => {
  try {
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = "downloaded-image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the image:", error);
  }
};

// format date like "12-4-2025, 10:00 AM"
export const formatDateAndHour = (dateString: string, showTime: boolean) => {
  const date = new Date(dateString);

  // Check if the date is valid
  if (!dateString || isNaN(date.getTime())) {
    return "";
  }

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (!showTime) {
    return `${day}-${month}-${year}`;
  }

  const time = new Date(dateString + "Z");
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return `${day}-${month}-${year}, ${time.toLocaleString("en-US", options)}`;
};

export const convertUtcToLocalDateTime=(dateTime:string)=>{
  const formattedDate = new Date(dateTime)
  .toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  })
  .replace(/\//g, '-');
return formattedDate;
}

export const convertUtcToLocalMonthDateTime = (dateTime: string): string => {
  const formattedDate = new Date(dateTime)
  .toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  return formattedDate;
};

export const convertUtcToLocalDate=(date:string)=>{
  const formattedDate = new Date(date)
  .toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  })
  .replace(/\//g, '-');
return formattedDate;
}

// Check if enum has flag.
export const hasFlag = (inputType: number, flag: number): boolean =>
  (inputType & flag) === flag;
